import { render, staticRenderFns } from "./SignUpNewUserTwo.vue?vue&type=template&id=45d03f36&scoped=true"
import script from "./SignUpNewUserTwo.vue?vue&type=script&lang=js"
export * from "./SignUpNewUserTwo.vue?vue&type=script&lang=js"
import style0 from "./SignUpNewUserTwo.vue?vue&type=style&index=0&id=45d03f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d03f36",
  null
  
)

export default component.exports